export const Socials = {
  LinkedIn: "https://www.linkedin.com/company/meidly",
  X: "",
  Instagram: "",
  Tiktok: "",
  Youtube: "",
};
